export default __webpack_public_path__ + "static/media/home-banner-mobile-gh.75635320.webp";